<template>
  <section class="promotion-detail">
    <div class="flex flex-sb-center">
      <h2 >Manage Notice/News</h2>
      <div>
        <v-button>Cancel</v-button>
        <v-button type="primary">Save</v-button>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="button-bottom">
        <v-button type="info">Add News</v-button>
      </div>
      <div >
        <div class="">
          <div  class="content-container  ">
            <div >
              <div class="form-item">
                <span>Date</span>
                <el-form-item
                >
                  <v-input />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Content</span>
                <el-form-item
                >
                  <v-input
                    type="textarea"
                    :rows="8"/>
                </el-form-item>
              </div>
            </div>
            <div>
              <div class="form-item">
                <span>Attached Files</span>
                <file-container
                  :edit="true"
                  titleName= "Attached Files"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess" />

              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </section>
</template>
<script>
import {
  addPromoArticle,
  getPromoCategoriesList,
  getPromoArticleDetail,
  updatePromoArticleDetail,
  deletePromoArticle,
  uploadNewsImage } from '@/api/news'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
export default {
  name: 'planForm',
  mixins: [MixinOptions, MixinRules],
  data() {
    return {
      formData:{}
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    handlerDeleteFile(){

    },
    handlerUploadSuccess(){

    },
    network() {
      return {
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.promotion-detail {
  position: relative;
  padding-bottom: 200px;
  .header {
    h1 {
      display: inline-block;
      padding-right: 15px;
    }
  }
  .content-container, .content-form {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    & > div {
      width: calc(50% - 10px);
    }
  }

  .button-bottom{
    margin-bottom: 30px;
  }
}
</style>